import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"overflow":"auto","overflow-x":"hidden","height":"calc(100% - 80px)"}
}
const _hoisted_2 = {
  key: 0,
  style: {"padding":"0px 12px 12px 12px"}
}
const _hoisted_3 = {
  class: "ph-picture",
  style: {"height":"250px"}
}
const _hoisted_4 = {
  key: 0,
  style: {"position":"relative","width":"100%","height":"250px","overflow":"hidden","border-radius":"6px"}
}
const _hoisted_5 = {
  key: 1,
  style: {"overflow":"auto","height":"calc(100% - 72px)"}
}
const _hoisted_6 = {
  key: 0,
  style: {"height":"100%"}
}
const _hoisted_7 = {
  class: "table table-hover table-outlined table-responsive",
  style: {"display":"table !important"}
}
const _hoisted_8 = { class: "footerPanel" }
const _hoisted_9 = {
  key: 1,
  style: {"height":"100%"}
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "footerPanel" }
const _hoisted_13 = {
  key: 2,
  style: {"overflow":"auto","height":"calc(100% - 80px)"}
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 3,
  style: {"overflow":"auto","overflow-x":"hidden","height":"calc(100% - 80px)"}
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 3 }
const _hoisted_18 = { style: `{can_edit_devices ? '' : 'pointer-events: none !important;'}` }
const _hoisted_19 = { style: {"width":"100%","overflow":"auto","display":"grid","grid-template-columns":"repeat(10, 1fr)","flex-wrap":"wrap","gap":"10px"} }
const _hoisted_20 = { key: 6 }
const _hoisted_21 = { class: "custom-tabs" }
const _hoisted_22 = { class: "tab-label" }
const _hoisted_23 = { class: "tab-label" }
const _hoisted_24 = { class: "tab-label" }
const _hoisted_25 = { class: "tab-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_CameraWebRTCPlayer = _resolveComponent("CameraWebRTCPlayer")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")!
  const _component_b_table = _resolveComponent("b-table")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, {
          color: _ctx.darkMode ? 'dark' : ''
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('device')) + " - " + _toDisplayString(_ctx.device.name), 1)
              ], undefined, true),
              _: 1
            }),
            _createVNode(_component_ion_buttons, { slot: "primary" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  color: "danger",
                  fill: "outline",
                  onClickNative: _ctx.closeModal
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('cancel')), 1)
                  ], undefined, true),
                  _: 1
                }, 8, ["onClickNative"])
              ], undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        }, 8, ["color"])
      ], undefined, true),
      _: 1
    }),
    _createVNode(_component_ion_content, {
      class: "ion-padding",
      style: {"position":"relative","background-color":"var(--ion-color-white) !important"}
    }, {
      default: _withCtx(() => [
        (_ctx.selectedTab == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_ctx.can_view_cameras && (_ctx.loadingCamera || _ctx.cameraMonitorId > 0))
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _withDirectives(_createElementVNode("div", _hoisted_3, null, 512), [
                      [_vShow, _ctx.loadingCamera]
                    ]),
                    (_ctx.cameraMonitorId > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createVNode(_component_CameraWebRTCPlayer, {
                            onDragover: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
                            autoplay: true,
                            muted: true,
                            controls: _ctx.isMobile(),
                            url: _ctx.cameraUrl,
                            cameraId: _ctx.cameraMonitorId,
                            style: {"position":"absolute","top":"0","bottom":"0","left":"0","right":"0"}
                          }, null, 8, ["controls", "url", "cameraId"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.can_control_devices)
                ? (_openBlock(), _createBlock(_component_b_row, { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_col, null, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            class: "btn btn-success btn_custom",
                            type: "button",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.openGate();}),
                            style: {"width":"100%","height":"65px","margin":"20px 0px","margin-top":"0px","background-color":"#f03a3e","color":"white"}
                          }, _toDisplayString(_ctx.t('open_gate')), 1)
                        ], undefined, true),
                        _: 1
                      }),
                      _createVNode(_component_b_col, null, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            class: "btn btn-danger btn_custom",
                            type: "button",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.closeGate();}),
                            style: {"width":"100%","height":"65px","margin":"20px 0px","margin-top":"0px","background-color":"#39cc64","color":"white"}
                          }, _toDisplayString(_ctx.t('close_gate')), 1)
                        ], undefined, true),
                        _: 1
                      })
                    ], undefined, true),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.can_control_devices)
                ? (_openBlock(), _createBlock(_component_b_row, { key: 2 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_col, {
                        cols: "12",
                        sm: "6",
                        md: "6",
                        lg: "6",
                        xl: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, {
                                class: "item-has-value",
                                position: "floating"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('keep_open')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select, {
                                interface: "popover",
                                value: _ctx.keepOpenUntil,
                                onIonChangeNative: _cache[3] || (_cache[3] = ($event: any) => (_ctx.keepOpenUntil=$event.target.value)),
                                "ok-text": _ctx.t('SELECT.ok'),
                                "cancel-text": _ctx.t('SELECT.cancel')
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_select_option, { value: "0" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t('indefinitely')), 1)
                                    ], undefined, true),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_select_option, { value: "5" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t('5_minutes')), 1)
                                    ], undefined, true),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_select_option, { value: "10" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t('10_minutes')), 1)
                                    ], undefined, true),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_select_option, { value: "15" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t('15_minutes')), 1)
                                    ], undefined, true),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_select_option, { value: "30" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t('30_minutes')), 1)
                                    ], undefined, true),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_select_option, { value: "45" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t('45_minutes')), 1)
                                    ], undefined, true),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_select_option, { value: "60" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t('60_minutes')), 1)
                                    ], undefined, true),
                                    _: 1
                                  })
                                ], undefined, true),
                                _: 1
                              }, 8, ["value", "ok-text", "cancel-text"])
                            ], undefined, true),
                            _: 1
                          }),
                          _cache[166] || (_cache[166] = _createElementVNode("br", null, null, -1))
                        ], undefined, true),
                        _: 1
                      }),
                      _createVNode(_component_b_col, {
                        cols: "12",
                        sm: "6",
                        md: "6",
                        lg: "6",
                        xl: "6"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            class: "btn btn-danger btn_custom",
                            type: "button",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.triggerKeepGateOpen();}),
                            style: {"width":"100%","height":"65px","margin":"20px 0px","margin-top":"0px","background-color":"var(--ion-color-backgroundLight)"}
                          }, _toDisplayString(_ctx.t('keep_gate_open')), 1)
                        ], undefined, true),
                        _: 1
                      })
                    ], undefined, true),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              false
                ? (_openBlock(), _createBlock(_component_b_row, { key: 3 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_col, null, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            class: "btn btn-primary btn_custom",
                            type: "button",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.lostTicket();}),
                            style: {"width":"100%","height":"150px","margin":"20px 0px","margin-top":"0px","background-color":"#39cc64","color":"white"}
                          }, _toDisplayString(_ctx.t('lost_ticket')), 1)
                        ], undefined, true),
                        _: 1
                      })
                    ], undefined, true),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _cache[168] || (_cache[168] = _createElementVNode("br", null, null, -1)),
              _createVNode(_component_b_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_col, {
                    cols: "6",
                    sm: "6",
                    md: "6",
                    lg: "6",
                    xl: "6"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('status')), 1)
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_b_col, {
                    cols: "6",
                    sm: "6",
                    md: "6",
                    lg: "6",
                    xl: "6"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        style: _normalizeStyle(['flex: 1; flex-direction: row; color: ' + (_ctx.status == 'connected' ? '#39cc64' : (_ctx.status == 'disconnected' ? '#f03a3e' : '#f5a623')), {}])
                      }, [
                        _createElementVNode("div", {
                          style: _normalizeStyle('display: inline-block; width: 10px; height: 10px; border-radius: 5px; margin-top: 5px; margin-right: 10px; background-color: ' + (_ctx.status == 'connected' ? '#39cc64' : (_ctx.status == 'disconnected' ? '#f03a3e' : '#f5a623')))
                        }, null, 4),
                        _createTextVNode(_toDisplayString(_ctx.capitalizeFirstLetter(_ctx.t(_ctx.status))), 1)
                      ], 4)
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }),
              _createVNode(_component_b_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_col, {
                    cols: "6",
                    sm: "6",
                    md: "6",
                    lg: "6",
                    xl: "6"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('state')), 1)
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_b_col, {
                    cols: "6",
                    sm: "6",
                    md: "6",
                    lg: "6",
                    xl: "6"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        style: _normalizeStyle(['flex: 1; flex-direction: row; color: ' + (_ctx.state == 'unknown' ? '#e1e1e1' : (_ctx.state == 'closed' ? '#39cc64' : (_ctx.state == 'opened' ? '#f03a3e' : '#f5a623'))), {}])
                      }, [
                        _createElementVNode("div", {
                          style: _normalizeStyle('display: inline-block; width: 10px; height: 10px; border-radius: 5px; margin-top: 5px; margin-right: 10px; background-color: ' + (_ctx.state == 'unknown' ? '#e1e1e1' : (_ctx.state == 'closed' ? '#39cc64' : (_ctx.state == 'opened' ? '#f03a3e' : '#f5a623'))))
                        }, null, 4),
                        _createTextVNode(_toDisplayString(_ctx.capitalizeFirstLetter(_ctx.t(_ctx.state))), 1)
                      ], 4)
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }),
              _createVNode(_component_b_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_col, {
                    cols: "6",
                    sm: "6",
                    md: "6",
                    lg: "6",
                    xl: "6"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.capitalizeFirstLetter(_ctx.t('presence'))), 1)
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_b_col, {
                    cols: "6",
                    sm: "6",
                    md: "6",
                    lg: "6",
                    xl: "6"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        style: _normalizeStyle(['flex: 1; flex-direction: row; color: ' + (_ctx.present == 'unknown' ? '#e1e1e1' : (_ctx.present == 'no' ? '#39cc64' : '#f03a3e')), {}])
                      }, [
                        _createElementVNode("div", {
                          style: _normalizeStyle('display: inline-block; width: 10px; height: 10px; border-radius: 5px; margin-top: 5px; margin-right: 10px; background-color: ' + (_ctx.present == 'unknown' ? '#e1e1e1' : (_ctx.present == 'no' ? '#39cc64' : '#f03a3e')))
                        }, null, 4),
                        _createTextVNode(_toDisplayString(_ctx.capitalizeFirstLetter(_ctx.t(typeof _ctx.present == 'string' ? _ctx.present : 'unknown'))), 1)
                      ], 4)
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }),
              _createVNode(_component_b_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_col, {
                    cols: "6",
                    sm: "6",
                    md: "6",
                    lg: "6",
                    xl: "6"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('ip_addr')), 1)
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_b_col, {
                    cols: "6",
                    sm: "6",
                    md: "6",
                    lg: "6",
                    xl: "6"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.device.ipaddr), 1)
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }),
              _createVNode(_component_b_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_col, {
                    cols: "6",
                    sm: "6",
                    md: "6",
                    lg: "6",
                    xl: "6"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('mac_addr')), 1)
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_b_col, {
                    cols: "6",
                    sm: "6",
                    md: "6",
                    lg: "6",
                    xl: "6"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.device.macaddr), 1)
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }),
              _createVNode(_component_b_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_col, {
                    cols: "6",
                    sm: "6",
                    md: "6",
                    lg: "6",
                    xl: "6"
                  }, {
                    default: _withCtx(() => _cache[167] || (_cache[167] = [
                      _createTextVNode("Serial")
                    ]), undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_b_col, {
                    cols: "6",
                    sm: "6",
                    md: "6",
                    lg: "6",
                    xl: "6"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.device.serial_number), 1)
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.selectedTab == 4)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_ctx.can_view_events && _ctx.events_loaded == false && false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("table", _hoisted_7, [
                      _createElementVNode("colgroup", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events_fields, (field) => {
                          return (_openBlock(), _createElementBlock("col", {
                            style: {"width":"100px"},
                            key: `template_col_${field.key}`
                          }))
                        }), 128))
                      ]),
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events_fields, (field) => {
                            return (_openBlock(), _createElementBlock("th", {
                              key: `template_head_${field.key}`
                            }, [
                              _createVNode(_component_ion_skeleton_text, { animated: true })
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array(5), (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: `row_item_${index}`
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events_fields, (field) => {
                              return (_openBlock(), _createElementBlock("td", {
                                key: `template_cell_${field.key}`
                              }, [
                                _createVNode(_component_ion_skeleton_text, { animated: true })
                              ]))
                            }), 128))
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_ion_skeleton_text, {
                        animated: true,
                        style: {"width":"250px","height":"30px","margin-left":"10px"}
                      })
                    ])
                  ]))
                : (_ctx.can_view_events)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_b_table, {
                        "sticky-header": "",
                        hover: "",
                        outlined: "",
                        responsive: "",
                        busy: _ctx.events_loaded,
                        items: _ctx.events_items,
                        fields: _ctx.events_fields
                      }, {
                        "cell(name)": _withCtx((data) => [
                          _createTextVNode(_toDisplayString(_ctx.t(data.value)), 1)
                        ]),
                        "cell(description)": _withCtx((data) => [
                          _createTextVNode(_toDisplayString(_ctx.translate_description(data.value)), 1)
                        ]),
                        "cell(access_card)": _withCtx((data) => [
                          (data.value == null || typeof data.value.id == 'undefined' || data.value.id == 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_10))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                href: "javascript: void(0);",
                                onClick: ($event: any) => (_ctx.openAccessCard(data.value.id))
                              }, _toDisplayString('#' + _ctx.t(data.value.id) + ' - ' + _ctx.t(data.value.username)), 9, _hoisted_11))
                        ]),
                        "cell(date_at)": _withCtx((data) => [
                          _createTextVNode(_toDisplayString(_ctx.formatDate(data.value)), 1)
                        ]),
                        _: 1
                      }, 8, ["busy", "items", "fields"]),
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_b_pagination, {
                          modelValue: _ctx.events_page,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.events_page) = $event)),
                          "total-rows": _ctx.events_rows,
                          "per-page": 25
                        }, null, 8, ["modelValue", "total-rows"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.selectedTab == 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_ctx.barrier_type == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P101 – " + _toDisplayString(_ctx.t('barrier_speed')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.barrier_speed.toString(),
                          onIonChangeNative: _cache[7] || (_cache[7] = ($event: any) => (_ctx.elka_settings.barrier_speed = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('fast')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('standard')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('slow')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P103 – " + _toDisplayString(_ctx.t('power_supply')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.power_supply.toString(),
                          onIonChangeNative: _cache[8] || (_cache[8] = ($event: any) => (_ctx.elka_settings.power_supply = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('power_supply_standard')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('with_power_failure_detection')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P104 – " + _toDisplayString(_ctx.t('opening_limitation')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.opening_limitation.toString(),
                          onIonChangeNative: _cache[9] || (_cache[9] = ($event: any) => (_ctx.elka_settings.opening_limitation = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('barrier_opens_completly_90')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('opening_limitation_at_approx_85')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('opening_limitation_at_approx_80')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "3" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('opening_limitation_at_approx_75')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "4" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('opening_limitation_at_approx_70')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "5" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('opening_limitation_at_approx_65')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "6" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('opening_limitation_at_approx_60')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "7" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('opening_limitation_at_approx_55')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P105 – " + _toDisplayString(_ctx.t('limitation_safety')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.limitation_safety.toString(),
                          onIonChangeNative: _cache[10] || (_cache[10] = ($event: any) => (_ctx.elka_settings.limitation_safety = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('safety_devices_evaludated_any_position')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('no_evaluation_of_safety_sub_10_before_closed')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('no_evaluation_of_safety_sub_20_before_closed')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "3" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('no_evaluation_of_safety_sub_30')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode("P301 – " + _toDisplayString(_ctx.t('stay_open_time')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_input, {
                          type: "number",
                          min: 0,
                          max: 655,
                          value: _ctx.elka_settings.stay_open_time.toString(),
                          onChangeNative: _cache[11] || (_cache[11] = ($event: any) => (_ctx.elka_settings.stay_open_time = parseInt($event.target.value))),
                          onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.elka_settings.stay_open_time = parseInt($event.target.value)))
                        }, null, 8, ["value"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode("P302 – " + _toDisplayString(_ctx.t('prewarning_before_opening_time')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_input, {
                          type: "number",
                          min: 0,
                          max: 655,
                          value: _ctx.elka_settings.prewarning_before_opening_time.toString(),
                          onChangeNative: _cache[13] || (_cache[13] = ($event: any) => (_ctx.elka_settings.prewarning_before_opening_time = parseInt($event.target.value))),
                          onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.elka_settings.prewarning_before_opening_time = parseInt($event.target.value)))
                        }, null, 8, ["value"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode("P303 – " + _toDisplayString(_ctx.t('prewarning_before_closing_time')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_input, {
                          type: "number",
                          min: 0,
                          max: 655,
                          value: _ctx.elka_settings.prewarning_before_closing_time.toString(),
                          onChangeNative: _cache[15] || (_cache[15] = ($event: any) => (_ctx.elka_settings.prewarning_before_closing_time = parseInt($event.target.value))),
                          onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.elka_settings.prewarning_before_closing_time = parseInt($event.target.value)))
                        }, null, 8, ["value"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode("P401 – " + _toDisplayString(_ctx.t('maintenance_interval')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_input, {
                          type: "number",
                          min: 1,
                          max: 9999,
                          value: _ctx.elka_settings.maintenance_interval.toString(),
                          onChangeNative: _cache[17] || (_cache[17] = ($event: any) => (_ctx.elka_settings.maintenance_interval = parseInt($event.target.value))),
                          onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.elka_settings.maintenance_interval = parseInt($event.target.value)))
                        }, null, 8, ["value"])
                      ], undefined, true),
                      _: 1
                    }),
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (index) => {
                      return _createVNode(_component_ion_item, {
                        key: `relay_operatingMode_${index}`
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, {
                            class: "item-has-value",
                            position: "floating"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("P" + _toDisplayString(500 + index) + " – " + _toDisplayString(_ctx.t('relay_operating_mode')) + " #" + _toDisplayString(index), 1)
                            ], undefined, true),
                            _: 2
                          }, 1024),
                          _createVNode(_component_ion_select, {
                            interface: "popover",
                            value: _ctx.elka_settings.relay_operating_modes[index - 1],
                            onIonChangeNative: ($event: any) => (_ctx.elka_settings.relay_operating_modes[index - 1] = $event.target.value),
                            "ok-text": _ctx.t('SELECT.ok'),
                            "cancel-text": _ctx.t('SELECT.cancel')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_select_option, { value: "0" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('deactivated')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "1" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('error')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "2" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('maintenance')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "3" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('boom_missing')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "4" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('tandem_operation')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "5" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('red_traffic_light')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "6" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('green_traffic_light')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "7" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('warning_light')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "8" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('led_boom_lighting')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "9" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('activated_when_barrier_open')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "10" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('activated_when_barrier_closed')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "11" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('activated_via_bus')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "12" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('photoelectric_barrier_testing')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "13" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('barrier_emergency_released')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "14" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('presence')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "15" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('activated_when_loop_a_occupied')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "16" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('activated_when_loop_a_activated_notfaulty_notoccupied')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "17" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('pulse_when_loop_a_occupied')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "18" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('pulse_when_loop_a_cleared')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "19" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('activated_when_loop_b_occupied')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "20" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('activated_when_loop_b_activated_notfaulty_notoccupied')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "21" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('pulse_when_loop_b_occupied')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "22" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('pulse_when_loop_b_cleared')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "23" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('activated_when_loop_c_occupied')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "24" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('activated_when_loop_c_activated_notfaulty_notoccupied')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "25" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('pulse_when_loop_c_occupieday')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "26" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('pulse_when_loop_c_cleared')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "27" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('pulse_when_vehicle_counter_increment')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "28" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('pulse_when_vehicle_counter_decrement')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "29" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('pulse_when_dl_detected_passing_left')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "30" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('pulse_when_dl_detected_passing_right')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "31" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('on_when_barrier_closed')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "32" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('on_when_tcp_connected')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "33" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('on_when_powerfailuredetection_connected_andnofailure')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "34" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('activated_when_acousticsignaldevice_ison')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "35" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('ledboom_controlling_green_leds')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "36" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('ledboom_controlling_red_leds')), 1)
                                ], undefined, true),
                                _: 1
                              })
                            ], undefined, true),
                            _: 2
                          }, 1032, ["value", "onIonChangeNative", "ok-text", "cancel-text"])
                        ], undefined, true),
                        _: 2
                      }, 1024)
                    }), 64)),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P510 – " + _toDisplayString(_ctx.t('rtapl_end_pos_closed')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.rtapl_end_pos_closed.toString(),
                          onIonChangeNative: _cache[19] || (_cache[19] = ($event: any) => (_ctx.elka_settings.rtapl_end_pos_closed = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('off')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('on')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('flashing')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P511 – " + _toDisplayString(_ctx.t('rtapl_before_opening')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.rtapl_before_opening.toString(),
                          onIonChangeNative: _cache[20] || (_cache[20] = ($event: any) => (_ctx.elka_settings.rtapl_end_pos_closed = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('off')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('on')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('flashing')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P512 – " + _toDisplayString(_ctx.t('rtapl_before_closing')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.rtapl_before_closing.toString(),
                          onIonChangeNative: _cache[21] || (_cache[21] = ($event: any) => (_ctx.elka_settings.rtapl_before_closing = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('off')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('on')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('flashing')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P513 – " + _toDisplayString(_ctx.t('rtapl_during_opening')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.rtapl_during_opening.toString(),
                          onIonChangeNative: _cache[22] || (_cache[22] = ($event: any) => (_ctx.elka_settings.rtapl_during_opening = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('off')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('on')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('flashing')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P514 – " + _toDisplayString(_ctx.t('rtapl_during_closing')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.rtapl_during_closing.toString(),
                          onIonChangeNative: _cache[23] || (_cache[23] = ($event: any) => (_ctx.elka_settings.rtapl_during_closing = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('off')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('on')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('flashing')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P515 – " + _toDisplayString(_ctx.t('rtapl_during_intermediate_stop')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.rtapl_during_intermediate_stop.toString(),
                          onIonChangeNative: _cache[24] || (_cache[24] = ($event: any) => (_ctx.elka_settings.rtapl_during_intermediate_stop = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('off')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('on')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('flashing')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P516 – " + _toDisplayString(_ctx.t('rtapl_end_pos_open')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.rtapl_end_pos_open.toString(),
                          onIonChangeNative: _cache[25] || (_cache[25] = ($event: any) => (_ctx.elka_settings.rtapl_end_pos_open = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('off')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('on')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('flashing')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P520 – " + _toDisplayString(_ctx.t('gnapl_end_pos_closed')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.gnapl_end_pos_closed.toString(),
                          onIonChangeNative: _cache[26] || (_cache[26] = ($event: any) => (_ctx.elka_settings.gnapl_end_pos_closed = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('off')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('on')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('flashing')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P521 – " + _toDisplayString(_ctx.t('gnapl_before_opening')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.gnapl_before_opening.toString(),
                          onIonChangeNative: _cache[27] || (_cache[27] = ($event: any) => (_ctx.elka_settings.gnapl_before_opening = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('off')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('on')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('flashing')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P522 – " + _toDisplayString(_ctx.t('gnapl_before_closing')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.gnapl_before_closing.toString(),
                          onIonChangeNative: _cache[28] || (_cache[28] = ($event: any) => (_ctx.elka_settings.gnapl_before_closing = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('off')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('on')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('flashing')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P523 – " + _toDisplayString(_ctx.t('gnapl_during_opening')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.gnapl_during_opening.toString(),
                          onIonChangeNative: _cache[29] || (_cache[29] = ($event: any) => (_ctx.elka_settings.gnapl_during_opening = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('off')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('on')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('flashing')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P524 – " + _toDisplayString(_ctx.t('gnapl_during_closing')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.gnapl_during_closing.toString(),
                          onIonChangeNative: _cache[30] || (_cache[30] = ($event: any) => (_ctx.elka_settings.gnapl_during_closing = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('off')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('on')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('flashing')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P525 – " + _toDisplayString(_ctx.t('gnapl_during_intermediate_stop')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.gnapl_during_intermediate_stop.toString(),
                          onIonChangeNative: _cache[31] || (_cache[31] = ($event: any) => (_ctx.elka_settings.gnapl_during_intermediate_stop = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('off')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('on')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('flashing')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P526 – " + _toDisplayString(_ctx.t('gnapl_end_pos_open')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.gnapl_end_pos_open.toString(),
                          onIonChangeNative: _cache[32] || (_cache[32] = ($event: any) => (_ctx.elka_settings.gnapl_end_pos_open = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('off')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('on')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('flashing')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P530 – " + _toDisplayString(_ctx.t('warning_end_pos_closed')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.warning_end_pos_closed.toString(),
                          onIonChangeNative: _cache[33] || (_cache[33] = ($event: any) => (_ctx.elka_settings.warning_end_pos_closed = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('off')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('on')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('flashing')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P531 – " + _toDisplayString(_ctx.t('warning_before_opening')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.warning_before_opening.toString(),
                          onIonChangeNative: _cache[34] || (_cache[34] = ($event: any) => (_ctx.elka_settings.warning_before_opening = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('off')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('on')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('flashing')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P532 – " + _toDisplayString(_ctx.t('warning_before_closing')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.warning_before_closing.toString(),
                          onIonChangeNative: _cache[35] || (_cache[35] = ($event: any) => (_ctx.elka_settings.warning_before_closing = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('off')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('on')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('flashing')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P533 – " + _toDisplayString(_ctx.t('warning_during_opening')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.warning_during_opening.toString(),
                          onIonChangeNative: _cache[36] || (_cache[36] = ($event: any) => (_ctx.elka_settings.warning_during_opening = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('off')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('on')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('flashing')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P534 – " + _toDisplayString(_ctx.t('warning_during_closing')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.warning_during_closing.toString(),
                          onIonChangeNative: _cache[37] || (_cache[37] = ($event: any) => (_ctx.elka_settings.warning_during_closing = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('off')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('on')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('flashing')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P535 – " + _toDisplayString(_ctx.t('warning_during_intermediate_stop')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.warning_during_intermediate_stop.toString(),
                          onIonChangeNative: _cache[38] || (_cache[38] = ($event: any) => (_ctx.elka_settings.warning_during_intermediate_stop = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('off')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('on')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('flashing')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P536 – " + _toDisplayString(_ctx.t('warning_end_pos_open')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.warning_end_pos_open.toString(),
                          onIonChangeNative: _cache[39] || (_cache[39] = ($event: any) => (_ctx.elka_settings.warning_end_pos_open = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('off')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('on')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('flashing')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P540 – " + _toDisplayString(_ctx.t('bt_combi_selection')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.bt_combi_selection.toString(),
                          onIonChangeNative: _cache[40] || (_cache[40] = ($event: any) => (_ctx.elka_settings.bt_combi_selection = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('bt_push_button_sequence_logic')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('bta3_push_button_open')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('btz1b_push_button_close')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P541 – " + _toDisplayString(_ctx.t('force_monitoring')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.force_monitoring.toString(),
                          onIonChangeNative: _cache[41] || (_cache[41] = ($event: any) => (_ctx.elka_settings.force_monitoring = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('force_monitoring_with_stop_and_immediate_reopening')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('force_monitoring_with_stop')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P542 – " + _toDisplayString(_ctx.t('photoelectric_barrier_mode')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.photoelectric_barrier_mode.toString(),
                          onIonChangeNative: _cache[42] || (_cache[42] = ($event: any) => (_ctx.elka_settings.photoelectric_barrier_mode = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('stop_and_immediate_opening')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('stop')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P543 – " + _toDisplayString(_ctx.t('photoelectric_barrier_closing_auto')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.photoelectric_barrier_closing_auto.toString(),
                          onIonChangeNative: _cache[43] || (_cache[43] = ($event: any) => (_ctx.elka_settings.photoelectric_barrier_closing_auto = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('deactivated')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('activated')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P544 – " + _toDisplayString(_ctx.t('ls_test')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.ls_test.toString(),
                          onIonChangeNative: _cache[44] || (_cache[44] = ($event: any) => (_ctx.elka_settings.ls_test = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('deactivated')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('activated')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P545 – " + _toDisplayString(_ctx.t('induction_loop_safety_mode')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.induction_loop_safety_mode.toString(),
                          onIonChangeNative: _cache[45] || (_cache[45] = ($event: any) => (_ctx.elka_settings.induction_loop_safety_mode = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('stop_and_immediate_opening')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('stop_freeze')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P546 – " + _toDisplayString(_ctx.t('immediate_closing')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.immediate_closing.toString(),
                          onIonChangeNative: _cache[46] || (_cache[46] = ($event: any) => (_ctx.elka_settings.immediate_closing = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('closing_after_open_completed')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('closing_immediately')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P547 – " + _toDisplayString(_ctx.t('dead_mans_mode')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.dead_mans_mode.toString(),
                          onIonChangeNative: _cache[47] || (_cache[47] = ($event: any) => (_ctx.elka_settings.dead_mans_mode = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('self_holding_function')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('dead_mans_mode_enabled')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P548 – " + _toDisplayString(_ctx.t('boom_missing_function')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.boom_missing_function.toString(),
                          onIonChangeNative: _cache[48] || (_cache[48] = ($event: any) => (_ctx.elka_settings.boom_missing_function = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('no_stop')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('stop')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P549 – " + _toDisplayString(_ctx.t('auto_sync_function')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.auto_sync_function.toString(),
                          onIonChangeNative: _cache[49] || (_cache[49] = ($event: any) => (_ctx.elka_settings.auto_sync_function = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('deactivated')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('activated')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (index) => {
                      return _createVNode(_component_ion_item, {
                        key: `relay_operatingMode_${index}`
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, {
                            class: "item-has-value",
                            position: "floating"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("P" + _toDisplayString((560 + (index - 1))) + " – " + _toDisplayString(_ctx.t('relay_operating_mode')) + " #" + _toDisplayString(index + 6), 1)
                            ], undefined, true),
                            _: 2
                          }, 1024),
                          _createVNode(_component_ion_select, {
                            interface: "popover",
                            value: _ctx.elka_settings.relay_operating_modes[(index + 6) - 1],
                            onIonChangeNative: ($event: any) => (_ctx.elka_settings.relay_operating_modes[(index + 6) - 1] = $event.target.value),
                            "ok-text": _ctx.t('SELECT.ok'),
                            "cancel-text": _ctx.t('SELECT.cancel')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_select_option, { value: "0" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('deactivated')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "1" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('error')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "2" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('maintenance')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "3" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('boom_missing')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "4" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('tandem_operation')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "5" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('red_traffic_light')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "6" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('green_traffic_light')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "7" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('warning_light')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "8" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('led_boom_lighting')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "9" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('activated_when_barrier_open')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "10" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('activated_when_barrier_closed')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "11" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('activated_via_bus')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "12" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('photoelectric_barrier_testing')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "13" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('barrier_emergency_released')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "14" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('presence')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "15" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('activated_when_loop_a_occupied')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "16" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('activated_when_loop_a_activated_notfaulty_notoccupied')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "17" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('pulse_when_loop_a_occupied')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "18" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('pulse_when_loop_a_cleared')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "19" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('activated_when_loop_b_occupied')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "20" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('activated_when_loop_b_activated_notfaulty_notoccupied')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "21" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('pulse_when_loop_b_occupied')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "22" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('pulse_when_loop_b_cleared')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "23" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('activated_when_loop_c_occupied')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "24" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('activated_when_loop_c_activated_notfaulty_notoccupied')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "25" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('pulse_when_loop_c_occupieday')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "26" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('pulse_when_loop_c_cleared')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "27" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('pulse_when_vehicle_counter_increment')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "28" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('pulse_when_vehicle_counter_decrement')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "29" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('pulse_when_dl_detected_passing_left')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "30" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('pulse_when_dl_detected_passing_right')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "31" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('on_when_barrier_closed')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "32" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('on_when_tcp_connected')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "33" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('on_when_powerfailuredetection_connected_andnofailure')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "34" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('activated_when_acousticsignaldevice_ison')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "35" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('ledboom_controlling_green_leds')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "36" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('ledboom_controlling_red_leds')), 1)
                                ], undefined, true),
                                _: 1
                              })
                            ], undefined, true),
                            _: 2
                          }, 1032, ["value", "onIonChangeNative", "ok-text", "cancel-text"])
                        ], undefined, true),
                        _: 2
                      }, 1024)
                    }), 64)),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P570 – " + _toDisplayString(_ctx.t('barrier_type')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.barrier_type.toString(),
                          onIonChangeNative: _cache[50] || (_cache[50] = ($event: any) => (_ctx.elka_settings.barrier_type = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => _cache[169] || (_cache[169] = [
                                _createTextVNode("T3000")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => _cache[170] || (_cache[170] = [
                                _createTextVNode("T3500")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "3" }, {
                              default: _withCtx(() => _cache[171] || (_cache[171] = [
                                _createTextVNode("P2500")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "4" }, {
                              default: _withCtx(() => _cache[172] || (_cache[172] = [
                                _createTextVNode("P3000")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "5" }, {
                              default: _withCtx(() => _cache[173] || (_cache[173] = [
                                _createTextVNode("P3500")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "6" }, {
                              default: _withCtx(() => _cache[174] || (_cache[174] = [
                                _createTextVNode("P4000")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "7" }, {
                              default: _withCtx(() => _cache[175] || (_cache[175] = [
                                _createTextVNode("P5000")
                              ]), undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P601 – " + _toDisplayString(_ctx.t('loop_a_sensitivity')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.loop_a_sensitivity.toString(),
                          onIonChangeNative: _cache[51] || (_cache[51] = ($event: any) => (_ctx.elka_settings.loop_a_sensitivity = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => _cache[176] || (_cache[176] = [
                                _createTextVNode("0 (Min)")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => _cache[177] || (_cache[177] = [
                                _createTextVNode("1")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => _cache[178] || (_cache[178] = [
                                _createTextVNode("2")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "3" }, {
                              default: _withCtx(() => _cache[179] || (_cache[179] = [
                                _createTextVNode("3")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "4" }, {
                              default: _withCtx(() => _cache[180] || (_cache[180] = [
                                _createTextVNode("4")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "5" }, {
                              default: _withCtx(() => _cache[181] || (_cache[181] = [
                                _createTextVNode("5")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "6" }, {
                              default: _withCtx(() => _cache[182] || (_cache[182] = [
                                _createTextVNode("6")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "7" }, {
                              default: _withCtx(() => _cache[183] || (_cache[183] = [
                                _createTextVNode("7 (Max)")
                              ]), undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P603 – " + _toDisplayString(_ctx.t('loop_b_sensitivity')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.loop_b_sensitivity.toString(),
                          onIonChangeNative: _cache[52] || (_cache[52] = ($event: any) => (_ctx.elka_settings.loop_b_sensitivity = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => _cache[184] || (_cache[184] = [
                                _createTextVNode("0 (Min)")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => _cache[185] || (_cache[185] = [
                                _createTextVNode("1")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => _cache[186] || (_cache[186] = [
                                _createTextVNode("2")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "3" }, {
                              default: _withCtx(() => _cache[187] || (_cache[187] = [
                                _createTextVNode("3")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "4" }, {
                              default: _withCtx(() => _cache[188] || (_cache[188] = [
                                _createTextVNode("4")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "5" }, {
                              default: _withCtx(() => _cache[189] || (_cache[189] = [
                                _createTextVNode("5")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "6" }, {
                              default: _withCtx(() => _cache[190] || (_cache[190] = [
                                _createTextVNode("6")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "7" }, {
                              default: _withCtx(() => _cache[191] || (_cache[191] = [
                                _createTextVNode("7 (Max)")
                              ]), undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P602 – " + _toDisplayString(_ctx.t('loop_c_sensitivity')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.loop_c_sensitivity.toString(),
                          onIonChangeNative: _cache[53] || (_cache[53] = ($event: any) => (_ctx.elka_settings.loop_c_sensitivity = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => _cache[192] || (_cache[192] = [
                                _createTextVNode("0 (Min)")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => _cache[193] || (_cache[193] = [
                                _createTextVNode("1")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => _cache[194] || (_cache[194] = [
                                _createTextVNode("2")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "3" }, {
                              default: _withCtx(() => _cache[195] || (_cache[195] = [
                                _createTextVNode("3")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "4" }, {
                              default: _withCtx(() => _cache[196] || (_cache[196] = [
                                _createTextVNode("4")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "5" }, {
                              default: _withCtx(() => _cache[197] || (_cache[197] = [
                                _createTextVNode("5")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "6" }, {
                              default: _withCtx(() => _cache[198] || (_cache[198] = [
                                _createTextVNode("6")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "7" }, {
                              default: _withCtx(() => _cache[199] || (_cache[199] = [
                                _createTextVNode("7 (Max)")
                              ]), undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P610 – " + _toDisplayString(_ctx.t('loop_a_holdtime')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.loop_a_holdtime.toString(),
                          onIonChangeNative: _cache[54] || (_cache[54] = ($event: any) => (_ctx.elka_settings.loop_a_holdtime = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => _cache[200] || (_cache[200] = [
                                _createTextVNode("5 Minutes")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => _cache[201] || (_cache[201] = [
                                _createTextVNode("30 Minutes")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => _cache[202] || (_cache[202] = [
                                _createTextVNode("60 Minutes")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "3" }, {
                              default: _withCtx(() => _cache[203] || (_cache[203] = [
                                _createTextVNode("∞")
                              ]), undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P611 – " + _toDisplayString(_ctx.t('loop_b_holdtime')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.loop_b_holdtime.toString(),
                          onIonChangeNative: _cache[55] || (_cache[55] = ($event: any) => (_ctx.elka_settings.loop_b_holdtime = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => _cache[204] || (_cache[204] = [
                                _createTextVNode("5 Minutes")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => _cache[205] || (_cache[205] = [
                                _createTextVNode("30 Minutes")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => _cache[206] || (_cache[206] = [
                                _createTextVNode("60 Minutes")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "3" }, {
                              default: _withCtx(() => _cache[207] || (_cache[207] = [
                                _createTextVNode("∞")
                              ]), undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P612 – " + _toDisplayString(_ctx.t('loop_c_holdtime')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.loop_c_holdtime.toString(),
                          onIonChangeNative: _cache[56] || (_cache[56] = ($event: any) => (_ctx.elka_settings.loop_c_holdtime = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => _cache[208] || (_cache[208] = [
                                _createTextVNode("5 Minutes")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => _cache[209] || (_cache[209] = [
                                _createTextVNode("30 Minutes")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => _cache[210] || (_cache[210] = [
                                _createTextVNode("60 Minutes")
                              ]), undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "3" }, {
                              default: _withCtx(() => _cache[211] || (_cache[211] = [
                                _createTextVNode("∞")
                              ]), undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P701 – " + _toDisplayString(_ctx.t('loop_a_activated')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.loop_a_activated.toString(),
                          onIonChangeNative: _cache[57] || (_cache[57] = ($event: any) => (_ctx.elka_settings.loop_a_activated = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('deactivated')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('activated')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P702 – " + _toDisplayString(_ctx.t('loop_a_fnc_enter')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.loop_a_fnc_enter.toString(),
                          onIonChangeNative: _cache[58] || (_cache[58] = ($event: any) => (_ctx.elka_settings.loop_a_fnc_enter = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('none')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('safety')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('opening')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P703 – " + _toDisplayString(_ctx.t('loop_a_fnc_exit')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.loop_a_fnc_exit.toString(),
                          onIonChangeNative: _cache[59] || (_cache[59] = ($event: any) => (_ctx.elka_settings.loop_a_fnc_exit = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('none')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('closing')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P704 – " + _toDisplayString(_ctx.t('loop_a_fnc_presence')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.loop_a_fnc_presence.toString(),
                          onIonChangeNative: _cache[60] || (_cache[60] = ($event: any) => (_ctx.elka_settings.loop_a_fnc_presence = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('none')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('reporting_presence')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('blocking_presence')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P711 – " + _toDisplayString(_ctx.t('loop_b_activated')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.loop_b_activated.toString(),
                          onIonChangeNative: _cache[61] || (_cache[61] = ($event: any) => (_ctx.elka_settings.loop_b_activated = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('deactivated')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('activated')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P712 – " + _toDisplayString(_ctx.t('loop_b_fnc_enter')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.loop_b_fnc_enter.toString(),
                          onIonChangeNative: _cache[62] || (_cache[62] = ($event: any) => (_ctx.elka_settings.loop_b_fnc_enter = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('none')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('safety')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('opening')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P713 – " + _toDisplayString(_ctx.t('loop_b_fnc_exit')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.loop_b_fnc_exit.toString(),
                          onIonChangeNative: _cache[63] || (_cache[63] = ($event: any) => (_ctx.elka_settings.loop_b_fnc_exit = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('none')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('closing')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P714 – " + _toDisplayString(_ctx.t('loop_b_fnc_presence')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.loop_b_fnc_presence.toString(),
                          onIonChangeNative: _cache[64] || (_cache[64] = ($event: any) => (_ctx.elka_settings.loop_b_fnc_presence = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('none')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('reporting_presence')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('blocking_presence')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P721 – " + _toDisplayString(_ctx.t('loop_c_activated')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.loop_c_activated.toString(),
                          onIonChangeNative: _cache[65] || (_cache[65] = ($event: any) => (_ctx.elka_settings.loop_c_activated = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('deactivated')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('activated')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P722 – " + _toDisplayString(_ctx.t('loop_c_fnc_enter')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.loop_c_fnc_enter.toString(),
                          onIonChangeNative: _cache[66] || (_cache[66] = ($event: any) => (_ctx.elka_settings.loop_c_fnc_enter = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('none')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('safety')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('opening')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P723 – " + _toDisplayString(_ctx.t('loop_c_fnc_exit')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.loop_c_fnc_exit.toString(),
                          onIonChangeNative: _cache[67] || (_cache[67] = ($event: any) => (_ctx.elka_settings.loop_c_fnc_exit = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('none')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('closing')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P724 – " + _toDisplayString(_ctx.t('loop_c_fnc_presence')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.loop_c_fnc_presence.toString(),
                          onIonChangeNative: _cache[68] || (_cache[68] = ($event: any) => (_ctx.elka_settings.loop_c_fnc_presence = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('none')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('reporting_presence')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('blocking_presence')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P730 – " + _toDisplayString(_ctx.t('dl1_input_selection')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.dl1_input_selection.toString(),
                          onIonChangeNative: _cache[69] || (_cache[69] = ($event: any) => (_ctx.elka_settings.dl1_input_selection = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('deactivated')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('left_loop_a_right_loop_b')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('left_loop_b_right_loop_a')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "3" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('left_loop_a_right_loop_c')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "4" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('left_loop_c_right_loop_a')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "5" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('left_loop_b_right_loop_c')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "6" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('left_loop_c_right_loop_b')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P731 – " + _toDisplayString(_ctx.t('dl1_fnc_passing_from_left')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.dl1_fnc_passing_from_left.toString(),
                          onIonChangeNative: _cache[70] || (_cache[70] = ($event: any) => (_ctx.elka_settings.dl1_fnc_passing_from_left = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('no_function')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('opening')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('closing')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P732 – " + _toDisplayString(_ctx.t('dl1_fnc_passing_from_right')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.dl1_fnc_passing_from_right.toString(),
                          onIonChangeNative: _cache[71] || (_cache[71] = ($event: any) => (_ctx.elka_settings.dl1_fnc_passing_from_right = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('no_function')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('opening')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('closing')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P733 – " + _toDisplayString(_ctx.t('dl1_vehicle_counting_type_from_left')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.dl1_vehicle_counting_type_from_left.toString(),
                          onIonChangeNative: _cache[72] || (_cache[72] = ($event: any) => (_ctx.elka_settings.dl1_vehicle_counting_type_from_left = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('no_function')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('increment_counter')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('decrement_counter')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P734 – " + _toDisplayString(_ctx.t('dl1_vehicle_counting_type_from_right')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.dl1_vehicle_counting_type_from_right.toString(),
                          onIonChangeNative: _cache[73] || (_cache[73] = ($event: any) => (_ctx.elka_settings.dl1_vehicle_counting_type_from_right = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('no_function')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('increment_counter')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('decrement_counter')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P735 – " + _toDisplayString(_ctx.t('dl1_fnc_entering_from_left')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.dl1_fnc_entering_from_left.toString(),
                          onIonChangeNative: _cache[74] || (_cache[74] = ($event: any) => (_ctx.elka_settings.dl1_fnc_entering_from_left = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('no_function')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('opening')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('closing')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P736 – " + _toDisplayString(_ctx.t('dl1_fnc_entering_from_right')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.dl1_fnc_entering_from_right.toString(),
                          onIonChangeNative: _cache[75] || (_cache[75] = ($event: any) => (_ctx.elka_settings.dl1_fnc_entering_from_right = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('no_function')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('opening')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('closing')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P737 – " + _toDisplayString(_ctx.t('dl1_fnc_report_entering_from_left')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.dl1_fnc_report_entering_from_left.toString(),
                          onIonChangeNative: _cache[76] || (_cache[76] = ($event: any) => (_ctx.elka_settings.dl1_fnc_report_entering_from_left = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('no_function')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('reporting_presence')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('blocking_presence_report')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P738 – " + _toDisplayString(_ctx.t('dl1_fnc_report_entering_from_right')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.dl1_fnc_report_entering_from_right.toString(),
                          onIonChangeNative: _cache[77] || (_cache[77] = ($event: any) => (_ctx.elka_settings.dl1_fnc_report_entering_from_right = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('no_function')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('reporting_presence')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('blocking_presence_report')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P740 – " + _toDisplayString(_ctx.t('dl2_input_selection')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.dl2_input_selection.toString(),
                          onIonChangeNative: _cache[78] || (_cache[78] = ($event: any) => (_ctx.elka_settings.dl2_input_selection = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('deactivated')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('left_loop_a_right_loop_b')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('left_loop_b_right_loop_a')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "3" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('left_loop_a_right_loop_c')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "4" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('left_loop_c_right_loop_a')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "5" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('left_loop_b_right_loop_c')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "6" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('left_loop_c_right_loop_b')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P741 – " + _toDisplayString(_ctx.t('dl2_fnc_passing_from_left')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.dl2_fnc_passing_from_left.toString(),
                          onIonChangeNative: _cache[79] || (_cache[79] = ($event: any) => (_ctx.elka_settings.dl2_fnc_passing_from_left = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('no_function')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('opening')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('closing')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P742 – " + _toDisplayString(_ctx.t('dl2_fnc_passing_from_right')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.dl2_fnc_passing_from_right.toString(),
                          onIonChangeNative: _cache[80] || (_cache[80] = ($event: any) => (_ctx.elka_settings.dl2_fnc_passing_from_right = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('no_function')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('opening')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('closing')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P743 – " + _toDisplayString(_ctx.t('dl2_vehicle_counting_type_from_left')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.dl2_vehicle_counting_type_from_left.toString(),
                          onIonChangeNative: _cache[81] || (_cache[81] = ($event: any) => (_ctx.elka_settings.dl2_vehicle_counting_type_from_left = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('no_function')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('increment_counter')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('decrement_counter')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P744 – " + _toDisplayString(_ctx.t('dl2_vehicle_counting_type_from_right')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.dl2_vehicle_counting_type_from_right.toString(),
                          onIonChangeNative: _cache[82] || (_cache[82] = ($event: any) => (_ctx.elka_settings.dl2_vehicle_counting_type_from_right = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('no_function')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('increment_counter')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('decrement_counter')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P745 – " + _toDisplayString(_ctx.t('dl2_fnc_entering_from_left')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.dl2_fnc_entering_from_left.toString(),
                          onIonChangeNative: _cache[83] || (_cache[83] = ($event: any) => (_ctx.elka_settings.dl2_fnc_entering_from_left = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('no_function')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('opening')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('closing')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P746 – " + _toDisplayString(_ctx.t('dl2_fnc_entering_from_right')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.dl2_fnc_entering_from_right.toString(),
                          onIonChangeNative: _cache[84] || (_cache[84] = ($event: any) => (_ctx.elka_settings.dl2_fnc_entering_from_right = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('no_function')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('opening')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('closing')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P747 – " + _toDisplayString(_ctx.t('dl2_fnc_report_entering_from_left')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.dl2_fnc_report_entering_from_left.toString(),
                          onIonChangeNative: _cache[85] || (_cache[85] = ($event: any) => (_ctx.elka_settings.dl2_fnc_report_entering_from_left = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('no_function')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('reporting_presence')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('blocking_presence_report')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          class: "item-has-value",
                          position: "floating"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("P748 – " + _toDisplayString(_ctx.t('dl2_fnc_report_entering_from_right')), 1)
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          value: _ctx.elka_settings.dl2_fnc_report_entering_from_right.toString(),
                          onIonChangeNative: _cache[86] || (_cache[86] = ($event: any) => (_ctx.elka_settings.dl2_fnc_report_entering_from_right = parseInt($event.target.value))),
                          "ok-text": _ctx.t('SELECT.ok'),
                          "cancel-text": _ctx.t('SELECT.cancel')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('no_function')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('reporting_presence')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('blocking_presence_report')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ], undefined, true),
                          _: 1
                        }, 8, ["value", "ok-text", "cancel-text"])
                      ], undefined, true),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "btn btn-secondary btn_custom",
                type: "button",
                onClick: _cache[87] || (_cache[87] = ($event: any) => {_ctx.saveDeviceConfig();}),
                style: {"width":"100%","margin":"20px 0px"}
              }, _toDisplayString(_ctx.t('save_config')), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.selectedTab == 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, {
                    class: "item-has-value",
                    position: "floating"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('name')), 1)
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_ion_input, {
                    disabled: !_ctx.can_edit_devices,
                    value: _ctx.name,
                    onChangeNative: _cache[88] || (_cache[88] = ($event: any) => (_ctx.name=$event.target.value)),
                    onChange: _cache[89] || (_cache[89] = ($event: any) => (_ctx.name=$event.target.value))
                  }, null, 8, ["disabled", "value"])
                ], undefined, true),
                _: 1
              }),
              _cache[221] || (_cache[221] = _createElementVNode("br", null, null, -1)),
              _createVNode(_component_b_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_col, {
                    cols: "12",
                    sm: "12",
                    md: "6",
                    lg: "6",
                    xl: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, {
                            class: "item-has-value",
                            position: "floating"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('brand')), 1)
                            ], undefined, true),
                            _: 1
                          }),
                          _createVNode(_component_ion_input, {
                            disabled: !_ctx.can_edit_devices,
                            value: _ctx.brand,
                            onChangeNative: _cache[90] || (_cache[90] = ($event: any) => (_ctx.brand=$event.target.value)),
                            onChange: _cache[91] || (_cache[91] = ($event: any) => (_ctx.brand=$event.target.value))
                          }, null, 8, ["disabled", "value"])
                        ], undefined, true),
                        _: 1
                      }),
                      _cache[212] || (_cache[212] = _createElementVNode("br", null, null, -1))
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_b_col, {
                    cols: "12",
                    sm: "12",
                    md: "6",
                    lg: "6",
                    xl: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, {
                            class: "item-has-value",
                            position: "floating"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('model')), 1)
                            ], undefined, true),
                            _: 1
                          }),
                          _createVNode(_component_ion_input, {
                            disabled: !_ctx.can_edit_devices,
                            value: _ctx.model,
                            onChangeNative: _cache[92] || (_cache[92] = ($event: any) => (_ctx.model=$event.target.value)),
                            onChange: _cache[93] || (_cache[93] = ($event: any) => (_ctx.model=$event.target.value))
                          }, null, 8, ["disabled", "value"])
                        ], undefined, true),
                        _: 1
                      }),
                      _cache[213] || (_cache[213] = _createElementVNode("br", null, null, -1))
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }),
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, {
                    class: "item-has-value",
                    position: "floating"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('zone')), 1)
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_ion_select, {
                    disabled: !_ctx.can_edit_devices,
                    interface: "popover",
                    modelValue: _ctx.zone_id,
                    "onUpdate:modelValue": _cache[94] || (_cache[94] = ($event: any) => ((_ctx.zone_id) = $event)),
                    onIonChangeNative: _cache[95] || (_cache[95] = ($event: any) => (_ctx.zone_id=$event.target.value)),
                    "ok-text": _ctx.t('SELECT.ok'),
                    "cancel-text": _ctx.t('SELECT.cancel')
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.all_zones, (zone) => {
                        return (_openBlock(), _createBlock(_component_ion_select_option, {
                          key: zone.id + '_short',
                          data: zone,
                          value: zone.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(zone.name), 1)
                          ], undefined, true),
                          _: 2
                        }, 1032, ["data", "value"]))
                      }), 128))
                    ], undefined, true),
                    _: 1
                  }, 8, ["disabled", "modelValue", "ok-text", "cancel-text"])
                ], undefined, true),
                _: 1
              }),
              _cache[222] || (_cache[222] = _createElementVNode("br", null, null, -1)),
              _createVNode(_component_b_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_col, {
                    cols: "12",
                    sm: "12",
                    md: "6",
                    lg: "6",
                    xl: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, {
                            class: "item-has-value",
                            position: "floating"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('Latitude')), 1)
                            ], undefined, true),
                            _: 1
                          }),
                          _createVNode(_component_ion_input, {
                            disabled: !_ctx.can_edit_devices,
                            value: _ctx.latitude,
                            onChangeNative: _cache[96] || (_cache[96] = ($event: any) => (_ctx.latitude=$event.target.value)),
                            onChange: _cache[97] || (_cache[97] = ($event: any) => (_ctx.latitude=$event.target.value))
                          }, null, 8, ["disabled", "value"])
                        ], undefined, true),
                        _: 1
                      }),
                      _cache[214] || (_cache[214] = _createElementVNode("br", null, null, -1))
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_b_col, {
                    cols: "12",
                    sm: "12",
                    md: "6",
                    lg: "6",
                    xl: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, {
                            class: "item-has-value",
                            position: "floating"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('Longitude')), 1)
                            ], undefined, true),
                            _: 1
                          }),
                          _createVNode(_component_ion_input, {
                            disabled: !_ctx.can_edit_devices,
                            value: _ctx.longitude,
                            onChangeNative: _cache[98] || (_cache[98] = ($event: any) => (_ctx.longitude=$event.target.value)),
                            onChange: _cache[99] || (_cache[99] = ($event: any) => (_ctx.longitude=$event.target.value))
                          }, null, 8, ["disabled", "value"])
                        ], undefined, true),
                        _: 1
                      }),
                      _cache[215] || (_cache[215] = _createElementVNode("br", null, null, -1))
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }),
              _createVNode(_component_b_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_col, {
                    cols: "12",
                    sm: "12",
                    md: "6",
                    lg: "6",
                    xl: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, {
                            class: "item-has-value",
                            position: "floating"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('type')), 1)
                            ], undefined, true),
                            _: 1
                          }),
                          _createVNode(_component_ion_select, {
                            disabled: !_ctx.can_edit_devices,
                            interface: "popover",
                            value: _ctx.type,
                            onIonChangeNative: _cache[100] || (_cache[100] = ($event: any) => (_ctx.type=$event.target.value)),
                            "ok-text": _ctx.t('SELECT.ok'),
                            "cancel-text": _ctx.t('SELECT.cancel')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_select_option, { value: "" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('none')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "Entrance gate" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('Entrance gate')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "Exit gate" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('Exit gate')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "Bidirectional gate" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('Bidirectional gate')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "Washing station" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('Washing station')), 1)
                                ], undefined, true),
                                _: 1
                              })
                            ], undefined, true),
                            _: 1
                          }, 8, ["disabled", "value", "ok-text", "cancel-text"])
                        ], undefined, true),
                        _: 1
                      }),
                      _cache[216] || (_cache[216] = _createElementVNode("br", null, null, -1))
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_b_col, {
                    cols: "12",
                    sm: "12",
                    md: "6",
                    lg: "6",
                    xl: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, {
                            class: "item-has-value",
                            position: "floating"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('type_barrier')), 1)
                            ], undefined, true),
                            _: 1
                          }),
                          _createVNode(_component_ion_select, {
                            disabled: !_ctx.can_edit_devices,
                            interface: "popover",
                            value: _ctx.barrier_type.toString(),
                            onIonChangeNative: _cache[101] || (_cache[101] = ($event: any) => (_ctx.barrier_type = parseInt($event.target.value))),
                            "ok-text": _ctx.t('SELECT.ok'),
                            "cancel-text": _ctx.t('SELECT.cancel')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_select_option, { value: "0" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('none')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "1" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("ELKA " + _toDisplayString(_ctx.t('Barrier')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "2" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Automatic Systems " + _toDisplayString(_ctx.t('Barrier')), 1)
                                ], undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "3" }, {
                                default: _withCtx(() => _cache[217] || (_cache[217] = [
                                  _createTextVNode("Lexoh IO Board")
                                ]), undefined, true),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "4" }, {
                                default: _withCtx(() => _cache[218] || (_cache[218] = [
                                  _createTextVNode("Modbus RTU Relay Module")
                                ]), undefined, true),
                                _: 1
                              })
                            ], undefined, true),
                            _: 1
                          }, 8, ["disabled", "value", "ok-text", "cancel-text"])
                        ], undefined, true),
                        _: 1
                      }),
                      _cache[219] || (_cache[219] = _createElementVNode("br", null, null, -1))
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }),
              (_ctx.barrier_type == 1)
                ? (_openBlock(), _createBlock(_component_ion_item, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, {
                        class: "item-has-value",
                        position: "floating"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('barrier_hostname')), 1)
                        ], undefined, true),
                        _: 1
                      }),
                      _createVNode(_component_ion_input, {
                        disabled: !_ctx.can_edit_devices,
                        value: _ctx.hostname,
                        onChangeNative: _cache[102] || (_cache[102] = ($event: any) => (_ctx.hostname=$event.target.value)),
                        onChange: _cache[103] || (_cache[103] = ($event: any) => (_ctx.hostname=$event.target.value))
                      }, null, 8, ["disabled", "value"])
                    ], undefined, true),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.barrier_type == 1)
                ? (_openBlock(), _createElementBlock("br", _hoisted_16))
                : _createCommentVNode("", true),
              (_ctx.barrier_type == 1)
                ? (_openBlock(), _createBlock(_component_ion_item, { key: 2 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, {
                        class: "item-has-value",
                        position: "floating"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('barrier_port')), 1)
                        ], undefined, true),
                        _: 1
                      }),
                      _createVNode(_component_ion_input, {
                        disabled: !_ctx.can_edit_devices,
                        type: "number",
                        value: _ctx.port,
                        onChangeNative: _cache[104] || (_cache[104] = ($event: any) => (_ctx.port=$event.target.value)),
                        onChange: _cache[105] || (_cache[105] = ($event: any) => (_ctx.port=$event.target.value))
                      }, null, 8, ["disabled", "value"])
                    ], undefined, true),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.barrier_type == 1)
                ? (_openBlock(), _createElementBlock("br", _hoisted_17))
                : _createCommentVNode("", true),
              (_ctx.barrier_type == 2)
                ? (_openBlock(), _createBlock(_component_ion_item, { key: 4 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, {
                        class: "item-has-value",
                        position: "floating"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('barrier_api_url')), 1)
                        ], undefined, true),
                        _: 1
                      }),
                      _createVNode(_component_ion_input, {
                        disabled: !_ctx.can_edit_devices,
                        value: _ctx.serverurl,
                        onChangeNative: _cache[106] || (_cache[106] = ($event: any) => (_ctx.serverurl=$event.target.value)),
                        onChange: _cache[107] || (_cache[107] = ($event: any) => (_ctx.serverurl=$event.target.value))
                      }, null, 8, ["disabled", "value"])
                    ], undefined, true),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _cache[223] || (_cache[223] = _createElementVNode("br", null, null, -1)),
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('prevent_customers_entry')), 1)
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_ion_toggle, {
                    disabled: !_ctx.can_edit_devices,
                    mode: "ios",
                    checked: _ctx.prevent_customers,
                    onIonChangeNative: _cache[108] || (_cache[108] = ($event: any) => (_ctx.prevent_customers = $event.target.checked))
                  }, null, 8, ["disabled", "checked"])
                ], undefined, true),
                _: 1
              }),
              _cache[224] || (_cache[224] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_ion_label, { style: {"color":"var(--ion-color-text03)"} }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('icon')), 1)
                  ], undefined, true),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", {
                    class: _normalizeClass(`icon_item` + (_ctx.icon == 1 ? ' selected' : '')),
                    onClick: _cache[109] || (_cache[109] = ($event: any) => (_ctx.icon = 1))
                  }, _cache[220] || (_cache[220] = [
                    _createElementVNode("img", { src: "/assets/icon/barrier_full.png" }, null, -1)
                  ]), 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(`icon_item` + (_ctx.icon == 2 ? ' selected' : '')),
                    onClick: _cache[111] || (_cache[111] = ($event: any) => (_ctx.icon = 2))
                  }, [
                    _createElementVNode("img", {
                      src: "/assets/icon/door_closed.png",
                      onClick: _cache[110] || (_cache[110] = ($event: any) => (_ctx.icon = 2))
                    })
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(`icon_item` + (_ctx.icon == 3 ? ' selected' : '')),
                    onClick: _cache[113] || (_cache[113] = ($event: any) => (_ctx.icon = 3))
                  }, [
                    _createElementVNode("img", {
                      src: "/assets/icon/camera.png",
                      onClick: _cache[112] || (_cache[112] = ($event: any) => (_ctx.icon = 3))
                    })
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(`icon_item` + (_ctx.icon == 4 ? ' selected' : '')),
                    onClick: _cache[115] || (_cache[115] = ($event: any) => (_ctx.icon = 4))
                  }, [
                    _createElementVNode("img", {
                      src: "/assets/icon/Boat.png",
                      onClick: _cache[114] || (_cache[114] = ($event: any) => (_ctx.icon = 4))
                    })
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(`icon_item` + (_ctx.icon == 5 ? ' selected' : '')),
                    onClick: _cache[117] || (_cache[117] = ($event: any) => (_ctx.icon = 5))
                  }, [
                    _createElementVNode("img", {
                      src: "/assets/icon/BoatWash.png",
                      onClick: _cache[116] || (_cache[116] = ($event: any) => (_ctx.icon = 5))
                    })
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(`icon_item` + (_ctx.icon == 6 ? ' selected' : '')),
                    onClick: _cache[119] || (_cache[119] = ($event: any) => (_ctx.icon = 6))
                  }, [
                    _createElementVNode("img", {
                      src: "/assets/icon/car.png",
                      onClick: _cache[118] || (_cache[118] = ($event: any) => (_ctx.icon = 6))
                    })
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(`icon_item` + (_ctx.icon == 7 ? ' selected' : '')),
                    onClick: _cache[121] || (_cache[121] = ($event: any) => (_ctx.icon = 7))
                  }, [
                    _createElementVNode("img", {
                      src: "/assets/icon/charging_station.png",
                      onClick: _cache[120] || (_cache[120] = ($event: any) => (_ctx.icon = 7))
                    })
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(`icon_item` + (_ctx.icon == 8 ? ' selected' : '')),
                    onClick: _cache[123] || (_cache[123] = ($event: any) => (_ctx.icon = 8))
                  }, [
                    _createElementVNode("img", {
                      src: "/assets/icon/emv.png",
                      onClick: _cache[122] || (_cache[122] = ($event: any) => (_ctx.icon = 8))
                    })
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(`icon_item` + (_ctx.icon == 9 ? ' selected' : '')),
                    onClick: _cache[125] || (_cache[125] = ($event: any) => (_ctx.icon = 9))
                  }, [
                    _createElementVNode("img", {
                      src: "/assets/icon/im30_insert blue.png",
                      onClick: _cache[124] || (_cache[124] = ($event: any) => (_ctx.icon = 9))
                    })
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(`icon_item` + (_ctx.icon == 10 ? ' selected' : '')),
                    onClick: _cache[127] || (_cache[127] = ($event: any) => (_ctx.icon = 10))
                  }, [
                    _createElementVNode("img", {
                      src: "/assets/icon/im30_swipe blue.png",
                      onClick: _cache[126] || (_cache[126] = ($event: any) => (_ctx.icon = 10))
                    })
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(`icon_item` + (_ctx.icon == 11 ? ' selected' : '')),
                    onClick: _cache[129] || (_cache[129] = ($event: any) => (_ctx.icon = 11))
                  }, [
                    _createElementVNode("img", {
                      src: "/assets/icon/im30_tap blue.png",
                      onClick: _cache[128] || (_cache[128] = ($event: any) => (_ctx.icon = 11))
                    })
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(`icon_item` + (_ctx.icon == 12 ? ' selected' : '')),
                    onClick: _cache[131] || (_cache[131] = ($event: any) => (_ctx.icon = 12))
                  }, [
                    _createElementVNode("img", {
                      src: "/assets/icon/intercom.png",
                      onClick: _cache[130] || (_cache[130] = ($event: any) => (_ctx.icon = 12))
                    })
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(`icon_item` + (_ctx.icon == 13 ? ' selected' : '')),
                    onClick: _cache[133] || (_cache[133] = ($event: any) => (_ctx.icon = 13))
                  }, [
                    _createElementVNode("img", {
                      src: "/assets/icon/pin_pad.png",
                      onClick: _cache[132] || (_cache[132] = ($event: any) => (_ctx.icon = 13))
                    })
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(`icon_item` + (_ctx.icon == 14 ? ' selected' : '')),
                    onClick: _cache[135] || (_cache[135] = ($event: any) => (_ctx.icon = 14))
                  }, [
                    _createElementVNode("img", {
                      src: "/assets/icon/license_plate.png",
                      onClick: _cache[134] || (_cache[134] = ($event: any) => (_ctx.icon = 14))
                    })
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(`icon_item` + (_ctx.icon == 15 ? ' selected' : '')),
                    onClick: _cache[137] || (_cache[137] = ($event: any) => (_ctx.icon = 15))
                  }, [
                    _createElementVNode("img", {
                      src: "/assets/icon/qr.png",
                      onClick: _cache[136] || (_cache[136] = ($event: any) => (_ctx.icon = 15))
                    })
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(`icon_item` + (_ctx.icon == 17 ? ' selected' : '')),
                    onClick: _cache[139] || (_cache[139] = ($event: any) => (_ctx.icon = 17))
                  }, [
                    _createElementVNode("img", {
                      src: "/assets/icon/rfid.png",
                      onClick: _cache[138] || (_cache[138] = ($event: any) => (_ctx.icon = 17))
                    })
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(`icon_item` + (_ctx.icon == 18 ? ' selected' : '')),
                    onClick: _cache[141] || (_cache[141] = ($event: any) => (_ctx.icon = 18))
                  }, [
                    _createElementVNode("img", {
                      src: "/assets/icon/subscription.png",
                      onClick: _cache[140] || (_cache[140] = ($event: any) => (_ctx.icon = 18))
                    })
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(`icon_item` + (_ctx.icon == 19 ? ' selected' : '')),
                    onClick: _cache[143] || (_cache[143] = ($event: any) => (_ctx.icon = 19))
                  }, [
                    _createElementVNode("img", {
                      src: "/assets/icon/assistance.png",
                      onClick: _cache[142] || (_cache[142] = ($event: any) => (_ctx.icon = 19))
                    })
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(`icon_item` + (_ctx.icon == 20 ? ' selected' : '')),
                    onClick: _cache[145] || (_cache[145] = ($event: any) => (_ctx.icon = 20))
                  }, [
                    _createElementVNode("img", {
                      src: "/assets/icon/house.png",
                      onClick: _cache[144] || (_cache[144] = ($event: any) => (_ctx.icon = 20))
                    })
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(`icon_item` + (_ctx.icon == 21 ? ' selected' : '')),
                    onClick: _cache[147] || (_cache[147] = ($event: any) => (_ctx.icon = 21))
                  }, [
                    _createElementVNode("img", {
                      src: "/assets/icon/qr2.png",
                      onClick: _cache[146] || (_cache[146] = ($event: any) => (_ctx.icon = 21))
                    })
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(`icon_item` + (_ctx.icon == 22 ? ' selected' : '')),
                    onClick: _cache[149] || (_cache[149] = ($event: any) => (_ctx.icon = 22))
                  }, [
                    _createElementVNode("img", {
                      src: "/assets/icon/washing_station_on.png",
                      onClick: _cache[148] || (_cache[148] = ($event: any) => (_ctx.icon = 22))
                    })
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(`icon_item` + (_ctx.icon == 23 ? ' selected' : '')),
                    onClick: _cache[151] || (_cache[151] = ($event: any) => (_ctx.icon = 23))
                  }, [
                    _createElementVNode("img", {
                      src: "/assets/icon/washing_station_off.png",
                      onClick: _cache[150] || (_cache[150] = ($event: any) => (_ctx.icon = 23))
                    })
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(`icon_item` + (_ctx.icon == 24 ? ' selected' : '')),
                    onClick: _cache[153] || (_cache[153] = ($event: any) => (_ctx.icon = 24))
                  }, [
                    _createElementVNode("img", {
                      src: "/assets/icon/boat_small.png",
                      onClick: _cache[152] || (_cache[152] = ($event: any) => (_ctx.icon = 24))
                    })
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(`icon_item` + (_ctx.icon == 25 ? ' selected' : '')),
                    onClick: _cache[155] || (_cache[155] = ($event: any) => (_ctx.icon = 25))
                  }, [
                    _createElementVNode("img", {
                      src: "/assets/icon/boat_medium.png",
                      onClick: _cache[154] || (_cache[154] = ($event: any) => (_ctx.icon = 25))
                    })
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(`icon_item` + (_ctx.icon == 26 ? ' selected' : '')),
                    onClick: _cache[157] || (_cache[157] = ($event: any) => (_ctx.icon = 26))
                  }, [
                    _createElementVNode("img", {
                      src: "/assets/icon/boat_large.png",
                      onClick: _cache[156] || (_cache[156] = ($event: any) => (_ctx.icon = 26))
                    })
                  ], 2)
                ])
              ]),
              (_ctx.can_edit_devices)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 5,
                    class: "btn btn-secondary btn_custom",
                    type: "button",
                    onClick: _cache[158] || (_cache[158] = ($event: any) => {_ctx.saveDeviceConfig();}),
                    style: {"width":"100%","margin":"20px 0px"}
                  }, _toDisplayString(_ctx.t('save_config')), 1))
                : _createCommentVNode("", true),
              (_ctx.can_edit_devices)
                ? (_openBlock(), _createElementBlock("br", _hoisted_20))
                : _createCommentVNode("", true),
              (_ctx.can_edit_devices)
                ? (_openBlock(), _createBlock(_component_b_row, { key: 7 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_col, null, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            class: "btn btn-success btn_custom",
                            type: "button",
                            onClick: _cache[159] || (_cache[159] = ($event: any) => {_ctx.openTerminal(_ctx.device);}),
                            style: {"width":"100%","height":"75px","margin":"20px 0px","margin-top":"0px","background-color":"#f03a3e","color":"white"}
                          }, _toDisplayString(_ctx.t('terminal')), 1)
                        ], undefined, true),
                        _: 1
                      })
                    ], undefined, true),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.can_control_devices || _ctx.can_edit_devices)
                ? (_openBlock(), _createBlock(_component_b_row, { key: 8 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_col, null, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            class: "btn btn-success btn_custom",
                            type: "button",
                            onClick: _cache[160] || (_cache[160] = ($event: any) => {_ctx.reboot();}),
                            style: {"width":"100%","height":"75px","margin":"20px 0px","margin-top":"0px","background-color":"#f03a3e","color":"white"}
                          }, _toDisplayString(_ctx.t('reboot')), 1)
                        ], undefined, true),
                        _: 1
                      })
                    ], undefined, true),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.can_control_devices || _ctx.can_edit_devices)
                ? (_openBlock(), _createBlock(_component_b_row, { key: 9 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_col, null, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            class: "btn btn-success btn_custom",
                            type: "button",
                            onClick: _cache[161] || (_cache[161] = ($event: any) => {_ctx.restartservice();}),
                            style: {"width":"100%","height":"75px","margin":"20px 0px","margin-top":"0px","background-color":"#f03a3e","color":"white"}
                          }, _toDisplayString(_ctx.t('restart_service')), 1)
                        ], undefined, true),
                        _: 1
                      })
                    ], undefined, true),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("a", {
            href: "javascript: void(0);",
            class: _normalizeClass(_ctx.selectedTab == 1 ? 'tab selected' : 'tab'),
            onClick: _cache[162] || (_cache[162] = ($event: any) => (_ctx.selectTab(1)))
          }, [
            _createVNode(_component_ion_icon, { icon: _ctx.list }, null, 8, ["icon"]),
            _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.t('overview')), 1)
          ], 2),
          _createElementVNode("a", {
            href: "javascript: void(0);",
            class: _normalizeClass(_ctx.selectedTab == 4 ? 'tab selected' : 'tab'),
            onClick: _cache[163] || (_cache[163] = ($event: any) => (_ctx.selectTab(4)))
          }, [
            _createVNode(_component_ion_icon, { icon: _ctx.calendarOutline }, null, 8, ["icon"]),
            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.t('events')), 1)
          ], 2),
          (_ctx.can_edit_devices && (_ctx.barrier_type == 1))
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: "javascript: void(0);",
                class: _normalizeClass(_ctx.selectedTab == 2 ? 'tab selected' : 'tab'),
                onClick: _cache[164] || (_cache[164] = ($event: any) => (_ctx.selectTab(2)))
              }, [
                _createVNode(_component_ion_icon, { icon: _ctx.gitNetwork }, null, 8, ["icon"]),
                _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.t('signals')), 1)
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("a", {
            href: "javascript: void(0);",
            class: _normalizeClass(_ctx.selectedTab == 3 ? 'tab selected' : 'tab'),
            onClick: _cache[165] || (_cache[165] = ($event: any) => (_ctx.selectTab(3)))
          }, [
            _createVNode(_component_ion_icon, { icon: _ctx.cog }, null, 8, ["icon"]),
            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.t('configuration')), 1)
          ], 2)
        ])
      ], undefined, true),
      _: 1
    })
  ], 64))
}